$(document).ready(function(){

  //Video play or pause button click start
    const video = $('#player')[0];
    const playIcon = $('.video-play');
    const pauseIcon = $('.video-pause');

    // Initial icon state
    playIcon.show();
    pauseIcon.hide();

    // Toggle play/pause function
    const togglePlayPause = () => {
        if (video.paused) {
            video.play();
            playIcon.hide();
            pauseIcon.show();
        } else {
            video.pause();
            playIcon.show();
            pauseIcon.hide();
        }
    };

    // Update the icon based on the video state
    const updateIcon = () => {
        if (video.paused) {
            playIcon.show();
            pauseIcon.hide();
        } else {
            playIcon.hide();
            pauseIcon.show();
        }
    };

    // Add event listeners
    $(document).on('click', '.video_cstm_url video', function(ev) {
        ev.preventDefault();
        togglePlayPause();
    });

    // Ensure the icon updates when play/pause events are triggered
    $(video).on('play pause', updateIcon);
    playIcon.on('click', function(ev) {
        ev.stopPropagation(); // Prevent the event from bubbling up to the video
        video.play();
        playIcon.hide();
        pauseIcon.show();
    });
    
    pauseIcon.on('click', function(ev) {
        ev.stopPropagation(); // Prevent the event from bubbling up to the video
        video.pause();
        playIcon.show();
        pauseIcon.hide();
    });
//Video play or pause button click end
 
  
 $(document).on('click','.video_cstm_url video' ,function(){
  setInterval(function(){
        if(document.activeElement instanceof HTMLIFrameElement){
            document.getElementById('cover').style.opacity=0;
            document.getElementById('player').style.opacity=1;
        }
    } , 50);
 });



   




// TextImageSlideShow
$('.variable-width').slick({
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  centerMode: true,
  variableWidth: false,
   prevArrow:
       '<svg class="slick-prev slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
  nextArrow:
      '<svg class="slick-next slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
});
  
//Featured collectio 
  
$('.multiple-items').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
   prevArrow:
         '<svg class="slick-prev slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
    nextArrow:
        '<svg class="slick-next slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',

  responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});
  
//collection list
  
  $('.collection_slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
         '<svg class="slick-prev slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
    nextArrow:
        '<svg class="slick-next slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


// You may also like section
$('.related-items').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
   prevArrow:
         '<svg class="slick-prev slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
    nextArrow:
        '<svg class="slick-next slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
    
});

//Slideshow
  
// $('.single-item').slick({
//   dots: true,
//   infinite: true,
//   autoplaySpeed: 3000,
//   autoplay: true, 
//   slidesToShow: 1,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   speed: 1000,
//   prevArrow:
//        '<svg class="slick-prev slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
//   nextArrow:
//       '<svg class="slick-next slick-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',  
// });
  
// $('html,body').addClass('activeHeader');
// $(window).scroll(function() {
//     var scroll = $(window).scrollTop();
//     if (scroll >= 100) {
//         $('html,body').removeClass('activeHeader');
//     } else {
// $('html,body').addClass('activeHeader');
//     }
// }); 




// Store locator Js//

 $(document).ready(function(){
  $(document).on('click', '#map_holder #map_inner svg path, #map_holder #map_inner rect, #map .itg-additional-states .btn.button', function() {
    var getValueState = $(this).attr('data-class');
    console.log(getValueState)
    $('.state-row[data-state]').each(function() {
      var getStateElement = $(this).attr('data-state');
      if(getValueState.indexOf(getStateElement)!= -1) {
        //$(this).attr('data-state');
        console.log($(this).attr('data-state'));
       // alert($(this).attr('data-state'));
          var $container = $("html,body");
          var $scrollTo = $(this);
          $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top },300); 
      }
    });
  });

   
    $(document).on('click', '.dealer-input-state .dealer-input-btn button', function(e){
      e.preventDefault();
 //    var stateVal = $(this).parent('.dealer-input-btn').find('input').val().replaceAll(' ', '-').replaceAll("'", "").replaceAll('&', '').toLowerCase();
       var stateVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '-').replace(/ /g,'-');
      stateVal = stateVal.replaceAll('--', '-');
      console.log(stateVal);
      var stateurl = (window.location.href).split('?')[0];
      // var stateUrlmain = stateurl.split('?')[0];
      console.log(stateurl);
      // var stateName = '?state';
      // console.log(stateName);
      window.location.replace(stateurl + '?state=' + stateVal);
    });

    $(document).on('click', '.dealer-input-city .dealer-input-btn button', function(e){
      e.preventDefault();
     // var cityVal = $(this).parent('.dealer-input-btn').find('input').val().replaceAll(' ', '-').replaceAll("'", "").replaceAll('&-', '').toLowerCase();
      var cityVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '-').replace(/ /g,'-');
      cityVal = cityVal.replaceAll('--', '-');
      console.log(cityVal);
      var cityurl = (window.location.href).split('?')[0];
      // var stateUrlmain = stateurl.split('?')[0];
      console.log(cityurl);
      // var stateName = '?state';
      // console.log(stateName);
      window.location.replace(cityurl + '?city=' + cityVal);
    });

    $(document).on('click', '.dealer-input-dealer .dealer-input-btn button', function(e){
      e.preventDefault();
   //   var dealerVal = $(this).parent('.dealer-input-btn').find('input').val().replaceAll(' ', '-').replaceAll("'", "").replaceAll('&', '').toLowerCase();
      var dealerVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '').replace(/ /g,'-');
      var dealerVal = dealerVal.replaceAll('--', '-');
      console.log(dealerVal);
      var dealerurl = (window.location.href).split('?')[0];
      // var stateUrlmain = stateurl.split('?')[0];
      console.log(dealerurl);
      // var stateName = '?state';
      // console.log(stateName);
      window.location.replace(dealerurl + '?dealer=' + dealerVal);
    });

    $(document).on('click', '.dealer-input-zipcode .dealer-input-btn button', function(e){
      e.preventDefault();
     // var cityVal = $(this).parent('.dealer-input-btn').find('input').val().replaceAll(' ', '-').replaceAll("'", "").replaceAll('&-', '').toLowerCase();
      var zipcodeVal = $(this).parent('.dealer-input-btn').find('input').val();
      zipcodeVal = zipcodeVal.replaceAll('--', '-');
      console.log(zipcodeVal);
      var zipcodeurl = (window.location.href).split('?')[0];
      // var stateUrlmain = stateurl.split('?')[0];
      console.log(zipcodeurl);
      // var stateName = '?state';
      // console.log(stateName);
      window.location.replace(zipcodeurl + '?zip=' + zipcodeVal);
    });

});


  if(window.location.href.indexOf('?state=')!= -1){
    console.log('state');
      var stateHref = (window.location.href).split('=')[1];
    if(stateHref === null || stateHref === undefined || stateHref === ''){}else{
    $('body').addClass('locate-by-state');
    
    $('.dealer-locator-main .state-wrapper .state-row').each(function(){
      var stateAttr = $(this).attr('data-state');
      // console.log(stateAttr);
      if(stateAttr.indexOf(stateHref)!= -1){
        // console.log('stateAttr');
        $(this).show();
        var $container = $("html,body");
        var $scrollTo = $(this);
        $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top },300); 
      }else{
        $(this).hide();
      }
    });
    }
  }

  if(window.location.href.indexOf('?city=')!= -1){
    console.log('city');    
    var cityHref = (window.location.href).split('=')[1];
    if(cityHref === null || cityHref === undefined || cityHref === ''){}else{
    $('body').addClass('locate-by-city');
    $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
      var cityAttr = $(this).attr('data-city');
      
      // console.log(stateAttr);
      if(cityAttr.indexOf(cityHref)!= -1){
        // console.log('stateAttr');
        $(this).parents('.state-row').addClass('active');
        $(this).addClass('sub-active');
      }
    });
    }
  }

  if(window.location.href.indexOf('?dealer=')!= -1){
    console.log('dealer');
    
    var dealerHref = (window.location.href).split('=')[1];
    console.log(dealerHref);
    if(dealerHref === null || dealerHref === undefined || dealerHref === ''){}else{
      $('body').addClass('locate-by-dealername');
      $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
        var dealerAttr = $(this).attr('data-dealer');
        console.log(dealerAttr);
        // console.log(stateAttr);
        if(dealerAttr.indexOf(dealerHref)!= -1){
          console.log('stateAttr');
          $(this).parents('.state-row').addClass('active');
          $(this).addClass('sub-active');
        }
      });
    }
  }


  if(window.location.href.indexOf('?zip=')!= -1){
    console.log('zip');    
    var zipcodeHref = (window.location.href).split('=')[1];
    if(zipcodeHref === null || zipcodeHref === undefined || zipcodeHref === ''){}else{
    $('body').addClass('locate-by-zipcode');
    $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
      var zipcodeAttr = $(this).attr('data-zipcode');
      
      // console.log(stateAttr);
      if(zipcodeAttr.indexOf(zipcodeHref)!= -1){
        // console.log('stateAttr');
        $(this).parents('.state-row').addClass('active');
          $(this).addClass('sub-active');
      }
    });
    }
  }

// Header mega-menu open/close (hover + keyboard focus + Escape) is now handled
// by the <header-menu> custom element in details-disclosure.js.

$(document).on('keyup','.search-modal__form', function(){
  $('.search-modal__form .field__label').hide();
});

  
  // $('.mega-menu').hover(function(){
  //   var dynamicId = $(this).attr('id');
  //   var menuItems = document.querySelectorAll('.mega-menu .active_image li a');
  //   var main_image = $(dynamicId).find('.custom_imageMenu.parent img').attr('src');
  //   menuItems.forEach(menuItem => {
  //     menuItem.addEventListener('mouseover', function() {
  //       const dataSrc = this.getAttribute('data-src');
  //       if (dataSrc) {
  //         $('#'+dynamicId).find('.custom_imageMenu.parent img').attr('src', dataSrc);
  //       }
  //     });
  //   });  
  // });


  $('.child.active_image .ITGmega-menu, .designer .active_image .ITGmega-menu, .grandchild_menu .grand_child_mega-menu').hover(function(){
    var dynamicId = $(this).attr('data-src');
    $(this).closest('.mega-menu,.header__submenu').find('.custom_imageMenu img').attr('src',dynamicId)
  });
  
});

// ------------collection page Scroll-------------
   var scroll_enable = $('#product-grid').attr('data-scroll');
    if(scroll_enable == 'enabled'){
   
   // Custom Collection infinite scroll
    $(window).on('scroll', function() {
      if( $(document).find('#Huratips-Pagination a').hasClass('loading') ){}else{
        $(document).find('#Huratips-Pagination a').addClass('loading').click();
      }
    });
    $(document).on('click','#Huratips-Pagination a',function(e) {
      e.preventDefault();
      var scrollURL = $(this).attr("href");
      $.ajax({
         type: 'GET',
         url: scrollURL,
         beforeSend: function(){},
         success: function(data) {
             if( $(data).find("#Huratips-Pagination").length ){                 
               var moreButton = $(data).find("#Huratips-Pagination").html();
               $(document).find("#Huratips-Pagination").html(moreButton);  
             }else{                 
               $(document).find("#Huratips-Pagination").remove();  
               $(document).find('.order_2').addClass('active');
             }
             var filteredData = $(data).find("#product-grid").html();
             $(document).find("#product-grid").append(filteredData);             
         },
         dataType: "html"
     });
    });
    }

 
  


// $(document).ready(function() {
//     function updateMargin() {
//         // Image height calculate karo
//         var imgHeight = $('.activeHeader .header__heading-logo-wrapper img.header__heading-logo').height();
//          const ImgHeight = imgHeight + 20;
//         // Margin-top ko image height ke barabar set karo
//           $('.activeHeader main#MainContent').css('margin-top', ImgHeight + 'px');  
//     }

//     // Initial margin-top set karo
//   setTimeout(function(){
//     updateMargin();
//   },1000);  

//     // Window resize hone par margin-top ko update karo
//     $(window).resize(function() {
//         updateMargin();
//     });

// });
document.addEventListener("DOMContentLoaded", function() {
    // function updateMargin() {
    //     // Image height calculate karo
    //     var imgElement = document.querySelector('.activeHeader .header__heading-logo-wrapper img.header__heading-logo');
    //     var imgHeight = imgElement ? imgElement.offsetHeight : 0;
    //     var imgHeightWithMargin = imgHeight + 20;

    //     // Margin-top ko image height ke barabar set karo
    //     var mainContent = document.querySelector('.activeHeader main#MainContent');
    //     if (mainContent) {
    //         mainContent.style.marginTop = imgHeightWithMargin + 'px';
    //     }
    // }

    // // Initial margin-top set karo
    // setTimeout(function() {
    //     updateMargin();
    // }, 1000);

    // // Window resize hone par margin-top ko update karo
    // window.addEventListener('resize', function() {
    //     updateMargin();
    // });
});


document.addEventListener("DOMContentLoaded", () => {
  const quantityButtons = document.querySelectorAll(".quantity__button");

  const updatePrice = () => {
    const priceElement = document.querySelector(".price__container .cstm_main_price");
    const currencyName = priceElement.getAttribute("currency");
    const currencySymbol = new Intl.NumberFormat('en-IN', { style: 'currency', currency: currencyName });
    const productVariantId = document.querySelector(".product-variant-id").getAttribute("value");
    const hiddenVariants = document.querySelectorAll(".hidden_variants li.variant");

    let getPrice;
    hiddenVariants.forEach(variant => {
      if (variant.getAttribute("variant_id") === productVariantId) {
        getPrice = parseInt(variant.getAttribute("variant_price").replace(/,/g, ''));
      }
    });

    const quantity = parseInt(document.querySelector(".quantity__input").value);
    if (quantity > 0 && !isNaN(quantity)) {
      let changePriceElements = document.querySelectorAll(".cstm_main_price");
      changePriceElements.forEach((ele)=>{
        ele.innerHTML = currencySymbol.format(quantity * getPrice);
      });
      // priceElement.innerHTML = currencySymbol.format(quantity * getPrice);
    }
  };
    if (document.body.classList.contains('kostaCtm__product')) {
      quantityButtons.forEach(button => button.addEventListener('click', updatePrice));
     let quantityInput = document.querySelector("input.quantity__input");
      quantityInput.addEventListener('input', updatePrice);
    }
  });

document.querySelector('.button_news .button')?.addEventListener('click', function() {
  if (document.querySelector('.email.mce_inline_error')) {
    document.querySelector('.button_news').classList.add('button_up');
  } else {
    document.querySelector('.button_news').classList.remove('button_up');
  }
});
